export default __webpack_public_path__ + "static/media/06ee829acdb71c40.8b965957fb62081897472a302e11a6eb.svg";